import React, { useState, useEffect } from "react";
import "./complaint.css";
import ComplaintDashHeader from "./ComplaintDashHeader";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import { getComplaintsDashboardData } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import ComplaintFirstSection from "./ComplaintFirstSection";
import ComplaintSecondSection from "./ComplaintSecondSection";
import { FaCalendar } from "react-icons/fa6";
import { DateRangePicker } from "react-date-range";
import DownloadReportModal from "../downloadReport/Modal";

const ComplaintsDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState("");
  const [amount, setAmount] = useState("");
  const [penalty, setPenalty] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [showGenerateReport, setShowGenerateReport] = useState(false);

  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(0, 0, 0, 0));
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(23, 59, 59, 999));
  });

  const [appliedStartDate, setAppliedStartDate] = useState(startDate);
  const [appliedEndDate, setAppliedEndDate] = useState(endDate);

  const [state, setState] = useState({
    selection: {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  });

  const token = useSelector((store) => store.userReducer.token);

  const fetchComplaintsDashboard = async (token, startDate, endDate) => {
    setIsLoading(true);

    const formattedStart = startDate.toISOString();
    const formattedEnd = endDate.toISOString();

    const response = await getComplaintsDashboardData(
      token,
      formattedStart,
      formattedEnd
    );

    setCount(response.count);
    setAmount(response.amount);
    setPenalty(response.fees);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchComplaintsDashboard(token, appliedStartDate, appliedEndDate);
  }, [token, appliedStartDate, appliedEndDate]);

  const handleSelect = (ranges) => {
    const { selection } = ranges;
    const selectedStartDate = new Date(selection.startDate);
    const selectedEndDate = new Date(selection.endDate);

    selectedStartDate.setHours(0, 0, 0, 0);
    selectedEndDate.setHours(23, 59, 59, 999);

    setStartDate(selectedStartDate);
    setEndDate(selectedEndDate);
    setState({ selection });
  };

  const handleApply = () => {
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setShowPicker(false);
  };

  return (
    <>
      <div className="recon-main-header">
        <ComplaintDashHeader />
        <div className="recon-header-date">
          <button
            className="search-btn-inactivee"
            onClick={() => setShowPicker(!showPicker)}
          >
            <FaCalendar />
          </button>
          {showPicker && (
            <div className="picker-box-2">
              <div className="date-range-picker-container">
                <DateRangePicker
                  ranges={[state.selection]}
                  onChange={handleSelect}
                  maxDate={new Date()}
                />
                <button onClick={handleApply} className="apply-button">
                  Apply
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="download-report-recon">
        <div className="">
          <h2>Download Reports</h2>
        </div>
        <div className="download-report-head">
          <button
            className="btn-report-recon"
            onClick={() => setShowGenerateReport(true)}
          >
            Generate Report
          </button>
        </div>
      </div>

      <div>
        <p className="overview" style={{ display: "flex", marginTop: "5px" }}>
          Selected Date Range:
          {state.selection.startDate && state.selection.endDate && (
            <span className="selectedOrg" style={{ marginLeft: "8px" }}>
              {new Date(state.selection.startDate).toLocaleDateString("en-GB")}{" "}
              - {new Date(state.selection.endDate).toLocaleDateString("en-GB")}
            </span>
          )}
        </p>
      </div>

      <>
        {isLoading ? (
          <ShimmerSimpleGallery
            className="shimmer-effect"
            row={1}
            col={3}
            imageHeight={200}
          />
        ) : (
          <ComplaintFirstSection
            count={count}
            amount={amount}
            penalty={penalty}
          />
        )}

        {isLoading ? (
          <ShimmerSimpleGallery
            className="shimmer-effect"
            row={1}
            col={1}
            imageHeight={200}
          />
        ) : (
          <ComplaintSecondSection amount={amount} penalty={penalty} />
        )}
      </>
      {showGenerateReport && (
        <DownloadReportModal onClose={() => setShowGenerateReport(false)} />
      )}
    </>
  );
};

export default ComplaintsDashboard;
